"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = ReCaptcha;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactUseinterval = _interopRequireDefault(require("react-useinterval"));

var _isReady = _interopRequireDefault(require("../utils/is-ready"));

var _loader = _interopRequireDefault(require("../utils/loader"));

var _unloader = _interopRequireDefault(require("../utils/unloader"));

var _cleaner = _interopRequireDefault(require("../utils/cleaner"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ReCaptcha({
  id,
  badge,
  size,
  onVerify,
  siteKey,
  action,
  theme,
  submitted
}) {
  const [ready, setReady] = (0, _react.useState)((0, _isReady.default)());
  const [client, setClient] = (0, _react.useState)(null);
  const [delay, setDelay] = (0, _react.useState)(1000);
  const [load, setLoad] = (0, _react.useState)(!ready && client === null);

  if (!load) {
    (0, _unloader.default)();
    setLoad(true);
  }

  (0, _react.useEffect)(() => {
    if (load) {
      (0, _loader.default)();
    }
  }, [load]);
  (0, _react.useEffect)(() => {
    return () => {
      (0, _unloader.default)();
      (0, _cleaner.default)(id);
    };
  }, []);
  (0, _reactUseinterval.default)(() => {
    if (ready && (0, _isReady.default)() && client === null) {
      render();
      setDelay(null);
    } else {
      if ((0, _isReady.default)()) {
        setReady(true);
      }
    }
  }, delay);

  const render = () => {
    try {
      window.grecaptcha.reset();
    } catch (ex) {
      setClient(null);
    }

    const response = window.grecaptcha.render(id, {
      sitekey: siteKey,
      badge,
      size,
      theme
    });
    setClient(response);
  };

  (0, _react.useEffect)(() => {
    if (ready && client !== null && submitted) {
      window.grecaptcha.execute(client, {
        action
      }).then(token => {
        if (typeof onVerify !== "undefined") {
          onVerify(token);
        }
      });
    }
  }, [submitted, ready, client]);
  return ready ? /*#__PURE__*/_react.default.createElement("div", {
    id: id
  }) : /*#__PURE__*/_react.default.createElement("div", {
    id: id,
    className: "g-recaptcha"
  });
}

ReCaptcha.propTypes = {
  id: _propTypes.default.string,
  badge: _propTypes.default.string,
  size: _propTypes.default.string,
  onVerify: _propTypes.default.func,
  submitted: _propTypes.default.bool.isRequired,
  siteKey: _propTypes.default.string.isRequired,
  action: _propTypes.default.string.isRequired,
  theme: _propTypes.default.string
};
ReCaptcha.defaultProps = {
  id: "g-recaptcha",
  badge: "inline",
  size: "invisible",
  theme: "light",
  action: "homepage",
  submitted: false
};